import { Joi, actionCreator, objectSchemaOf } from '../helpers';
import { USERS_OUTPUT } from './topics';
import type { IUser } from './user';
import { userSchema } from './user';

export const UPDATED = 'USERS/UPDATED' as const;

export interface IUpdatedAction {
  type: typeof UPDATED;
  payload: IUser;
}

export const updatedActionSchema = objectSchemaOf<IUpdatedAction>({
  type: Joi.string().valid(UPDATED).required(),
  payload: userSchema.required(),
});

export const updated = actionCreator({
  type: UPDATED,
  topic: USERS_OUTPUT,
  schema: updatedActionSchema,
});
